function SchedulerIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.4963 2.99609V5.99734" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5002 2.99609V5.99734" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.99609 9.49923H21.0036" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="2.99609" y="4.49707" width="18.0075" height="16.5069" rx="3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  
    );
  }
  
  export default SchedulerIcon;
  